var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',[_c('b-form-timepicker',_vm._b({attrs:{"disabled":_vm.disabled,"right":"","locale":_vm.$i18n.locale},on:{"input":_vm.handleInput},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'b-form-timepicker',_vm.labels,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }